export const nav_en = {
    menu: [
        {id: "top", title: "Top"},
        {id: "demo", title: "How"},
        {id: "pitch", title: "Why"},
        {id: "benefits", title: "Features"},
        {id: "steps", title: "Steps"},
        {id: "offer", title: "Join"},
        {id: "testimonials", title: "Testimonials"},
        {id: "faqs", title: "FAQ"},
    ],
    footer: [
        {"id": "home", "title": "Home", "path": "/"},
        {"id": "contact", "title": "Contact", "path": ""},
        {"id": "about", "title": "About", "path": "/about"},
        {"id": "terms", "title": "Terms", "path": "/terms"},
        {"id": "privacy", "title": "Privacy", "path": "/privacy"},
    ],
    copyright_text: "© 2025 Maze",
};

export const prompts_en = {
  prompt_buttons: [
    {"title": "Create a quick landing page"},
    {"title": "Test a new feature for my SaaS"},
    {"title": "Test copy for Marketing Campaings"},
    {"title": "Build a waitlist to collect emails"},
    {"title": "Something else"}
  ]
}

export const text_en = {
  "faq": {
    "items": [
      {
        "answer": "Tools like ChatGPT produce generic results that often feel flat and require heavy editing. Maze uses a custom model trained on SaaS to create persuasive, targeted copy that feels like it was written by a pro.",
        "question": "How is this different from ChatGPT?"
      },
      {
        "answer": "Maze performs deep research on your product and industry, analyzing user reviews, pain points, and desires from key sources to craft copy that truly resonates with your target audience.",
        "question": "How does the AI know what to write?"
      },
      {
        "answer": "Not at all. Maze is a no-code builder that handles all the design for you. You get modern, pre-designed modules that look great on any device, and you can easily edit text and images.",
        "question": "Do I need design skills to use this?"
      },
      {
        "answer": "No problem. You can regenerate your landing page as many times as you like, or easily edit the text and images manually until you're happy with it.",
        "question": "What if I don't like the result?"
      },
      {
        "answer": "Yes. Every page is generated with the best on-page SEO practices. You can even provide your own keywords to help you get found organically in search results.",
        "question": "Will my page be ready for search engines?"
      },
      {
        "answer": "Absolutely. Maze integrates with email signup forms, making it effortless to build an email list or a waitlist for your product launch.",
        "question": "Can I collect emails for a waitlist?"
      }
    ]
  },
  "hero": {
    "title": "Get Your SaaS Landing Page Live in Minutes. No Developer Needed",
    "subtitle": "Stop wasting time and money on designers and copywriters. Generate a high-converting SaaS landing page with a single click and start validating your ideas today.",
    "primaryCta": "Join the Waitlist",
    "offer_snippet": "Join the waitlist for early access and launch perks.",
    "proof_snippet": "\"This I can actually use.\" - @r4h4_de "
  },
  "demo": {
    "title": "See it in action"
  },
  "pitch": {
    "title": "Stuck between building your product and building your website?",
    "description": "As a founder, your time is your most valuable asset. Juggling product development with landing page design, copywriting, and coding is a recipe for burnout and slow progress. Generic tools give you clunky templates and weak copy, forcing you to do all the hard work anyway.",
    "pitch_compare": {
      "pitch_us_title": "The Maze Way",
      "pitch_others_title": "The Old Way",
      "pitch_us_description": [
        {
          "description": "Launch a new page in minutes."
        },
        {
          "description": "Save money for what matters."
        },
        {
          "description": "Get AI copy that actually converts."
        },
        {
          "description": "Test ideas at lightning speed."
        }
      ],
      "pitch_others_description": [
        {
          "description": "Wasting weeks on design and code."
        },
        {
          "description": "Blowing your budget on freelancers."
        },
        {
          "description": "Writing copy that doesn't convert."
        },
        {
          "description": "Slowing down your validation cycle."
        }
      ]
    }
  },
  "steps": {
    "items": [
      {
        "title": "Enter your SaaS details",
        "number": 1,
        "description": "Briefly tell us about your product, your target audience, and your goals."
      },
      {
        "title": "Click 'Generate'",
        "number": 2,
        "description": "Our AI gets to work, analyzing your info and crafting a complete landing page from scratch."
      },
      {
        "title": "Get Your Full Page",
        "number": 3,
        "description": "Receive a complete, ready-to-launch landing page with professional copy and design."
      }
    ],
    "title": "Your High-Converting Page in 3 Steps"
  },
  "pricing": {
    "type": "Waitlist",
    "plans": [
      {
        "cta": "Join the Waitlist",
        "name": "",
        "price": "",
        "features": [],
        "description": "Join our waitlist for early access and exclusive launch-day perks."
      }
    ],
    "title": "Be the First to Try Maze"
  },
  "features": {
    "items": [
      {
        "title": "One-Click Page Generation",
        "description": "Go from idea to a fully designed, high-converting landing page in a single click. No design or coding skills required."
      },
      {
        "title": "AI Copy That Converts",
        "description": "Our AI is trained on data from top-performing SaaS sites to write persuasive copy that speaks directly to your customers' needs."
      },
      {
        "title": "No-Code, Easy Editing",
        "description": "Effortlessly edit any text or image on your page. If you can write an email, you can use Maze."
      },
      {
        "title": "Built-in Waitlist Forms",
        "description": "Start building your audience from day one. Easily integrate email signup forms to capture leads and validate your idea."
      },
      {
        "title": "AI-Generated Visuals",
        "description": "Get unique, attention-grabbing images and product mockups generated for your page, making your SaaS look polished and professional."
      },
      {
        "title": "One-Click Updates",
        "description": "Just launched a new feature? Update your landing page in seconds to keep your messaging fresh and relevant."
      }
    ],
    "title": "Everything you need to launch and convert."
  },
  "finalCta": {
    "button": "Join the Waitlist",
    "phrase": "Stop wrestling with your website and get back to building your product."
  },
  "offer_nudge": "We're launching soon. Sign up to secure your spot!",
  "testimonials": {
    "items": [
      {
        "title": "This I can actually use",
        "author": "- @r4h4_de",
        "content": "I’ve tried other landing page copywriters but were not really happy with the output. This I can actually use. I was surprised this tool actually managed to tease out the core value proposition when it wasnt quite as clear in my original."
      },
      {
        "title": "The design is GENIUS!!",
        "author": "- @Nexau_com",
        "content": "This new feature that gives you the design is GENIUS!! I love how it gives it to me right there and I don’t have to wonder how to structure the website and what images to use as it is right there, it looks very good and works even better."
      },
      {
        "title": "This is pretty amazing!",
        "author": "- @NS7500",
        "content": "This is pretty amazing! The result is quite useful for me. Amazingly it got the main highlights and the FAQ section tells me what I missed."
      },
      {
        "title": "More clear than my current copy",
        "author": "- @unpluggedz0rs",
        "content": "This result is definitely more clear than my current copy in terms of the specific customer this is targeting."
      },
      {
        "title": "Helps with ideas as we try to improve",
        "author": "- @projectbios",
        "content": "It does help give a new perspective and helps with ideas as we try to improve our landing page for conversion."
      },
      {
        "title": "Wow that’s really good!",
        "author": "- Sean H.",
        "content": "Wow that’s really good! Was that a bot that did it?"
      }
    ],
    "title": "What Founders are Saying"
  }
};

export const support_en = {
  "about": {
    "title": "About Maze",
    "content": "Maze is a no-code AI-powered landing page generator designed specifically for SaaS founders. Our mission is to help you launch high-converting landing pages quickly and easily, so you can focus on building your product. With Maze, you can generate a complete landing page with professional copy and design in just minutes, without any coding or design skills required. Join our waitlist today and be the first to experience the future of landing page creation!"
  },
  "terms": {
    "title": "Terms of Service",
    "date": "Last updated: Sep 2025",
  },
  "privacy": {
    "title": "Privacy Policy",
    "date": "Last updated: Sep 2025",}
};
